import { MerchantReportsHome } from "../../merchant/home/pages/MerchantReportsHome"

export function MerchantAccountingHome() {
    return <MerchantReportsHome />
}
